import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';

const CheckboxProp = props => {
  const {
    checked = false,
    textColor = "black",
    size = null,
    label = "Start",
    text = "",
    textPosition = "start",
    onChange,
    onClick,
    fontSize = "14px",
    fontWeight = "none",
    disabled = false,
  } = props;

  const [state, setState] = React.useState(true);
  const [styles, setStyles] = React.useState({
    backgroundColor: "white",
    borderColor: "gray",
    checkedColor: "#3f51b5",
    textColor: "white"
  });

  const changeChecked = () => {
    if (onClick) {
      onClick();
    }
    if (onChange) {
      onChange(!checked);
    }
  }

  if (text && text != "") {
    return (
      <FormControl component="fieldset">
        <FormGroup aria-label="position" row>
          <FormControlLabel
            value="top"
            control={
              <div style={{ paddingLeft: 10 }}>
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    background: checked ? styles.checkedColor : styles.backgroundColor,
                    borderRadius: 3,
                    border: `1px solid ${styles.borderColor}`,
                    verticalAlign: 'middle',
                    textAlign: 'center',
                    cursor: 'pointer'
                  }}
                  onClick={changeChecked}
                >
                  <CheckIcon fontSize="small" style={{ fontWeight: "bold", color: checked ? styles.textColor : styles.backgroundColor }} />
                </div>
              </div>
            }
            label={
              <Typography
                style={{
                  color: textColor,
                  fontSize: fontSize,
                  fontFamily: "verdana",
                  fontWeight: fontWeight
                }}
              >
                {text}
              </Typography>
            }
            labelPlacement={textPosition}
          />
        </FormGroup>
      </FormControl>
    )
  }

  return (
    <div
      style={{
        width: '20px',
        height: '20px',
        background: checked ? styles.checkedColor : styles.backgroundColor,
        borderRadius: 3,
        border: `1px solid ${styles.borderColor}`,
        verticalAlign: 'middle',
        textAlign: 'center',
        cursor: 'pointer'
      }}
      onClick={changeChecked}
    >
      <CheckIcon fontSize="small" style={{ fontWeight: "bold", color: checked ? styles.textColor : styles.backgroundColor }} />
    </div>
  )
};

export default CheckboxProp;
